module.exports = __webpack_public_path__ + "img/overgame.9a7f2803.png";